module.exports = __webpack_public_path__ + "static/favicon-192-7ad818ad79c7f5e1db2c0c365908404c.png";